import { ImageVariants, MediaDTO } from '@/core/media/typings'
import { getDisplayImageUrl } from '@/core/media/utils/get-display-image-url'

type UrlVariants = Record<ImageVariants, string> & { url: string }

export const mainMediasFactory = (medias: MediaDTO[]): UrlVariants[] => {
  const main = medias.filter((m) => m.isMain)
  const defaultImg = '/default-property.png'

  const mapMediaUrlVariants = (url: string): UrlVariants => ({
    url,
    thumb: getDisplayImageUrl(url, ImageVariants.thumb),
    [ImageVariants['1920x1080']]: getDisplayImageUrl(url, ImageVariants['1920x1080']),
    [ImageVariants['600x600']]: getDisplayImageUrl(url, ImageVariants['600x600'])
  })

  if (main.length) {
    return main.map(({ url }) => mapMediaUrlVariants(url))
  }

  if (medias.length) {
    const url = medias[0].url
    return [mapMediaUrlVariants(url)]
  }

  return [
    {
      url: defaultImg,
      thumb: defaultImg,
      [ImageVariants['1920x1080']]: defaultImg,
      [ImageVariants['600x600']]: defaultImg
    }
  ]
}
